import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetaxihire() {



const cardData = {
  keyword: " Pune Taxi Hire",

"headingDescription": "Srs Cab Service offers reliable and comfortable taxi services across Pune, providing a hassle-free experience for airport transfers, business trips, family outings, and sightseeing. Our professional drivers, well-maintained vehicles, and punctual pickups ensure a safe and smooth journey. We provide flexible options including one-way rides, round trips, and customized travel plans, all with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Pune Taxi Hire is your trusted partner for all Pune travel needs.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort in Pune, known for its grand architecture and cultural significance as the seat of the Peshwas of the Maratha Empire. Travelers using Pune Taxi Hire often visit this landmark to admire the gates, explore the ruins, and capture memorable photographs of Pune’s rich heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a prominent historical landmark in Pune associated with Mahatma Gandhi and India’s freedom movement. Visitors traveling with Pune Taxi Hire can explore its majestic architecture, serene gardens, and museum exhibits, making it a must-visit for history enthusiasts."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, situated near Pune, is famous for its scenic views and historical importance in Maratha history. Travelers using Pune Taxi Hire often include this destination for trekking, panoramic vistas, and enjoying the natural beauty of Pune’s surrounding hills."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered temples dedicated to Lord Ganesha. Visitors using Pune Taxi Hire frequently stop here to seek blessings, experience the spiritual atmosphere, and witness local devotional traditions."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva located in central Pune. Travelers using Pune Taxi Hire can explore its unique carvings, enjoy the peaceful environment, and learn about this historical monument in the heart of the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum features an extensive collection of Indian artifacts including sculptures, musical instruments, and decorative arts. Visitors using Pune Taxi Hire can explore Pune’s cultural heritage and appreciate traditional craftsmanship preserved in the museum."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple is one of Pune’s oldest heritage sites, offering panoramic views of the city. Travelers using Pune Taxi Hire often climb the hill to enjoy scenic vistas, explore historic temples, and experience a blend of history and spirituality."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular getaway near Pune, known for its calm waters and scenic surroundings. Visitors using Pune Taxi Hire often stop here to enjoy photography, relaxing walks, and serene sunsets, making it an ideal spot for unwinding."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden, also called Pu La Deshpande Garden, is a tranquil Japanese-style garden. Travelers using Pune Taxi Hire can stroll through walking paths, enjoy lush greenery, and relax in the peaceful environment perfect for leisure and photography."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace in Pune linked to the childhood of Chhatrapati Shivaji Maharaj. Visitors using Pune Taxi Hire can explore this landmark to learn about Pune’s Maratha history, admire the architecture, and immerse themselves in the city’s cultural legacy."
  }
],



services: [
{
name: "Pune Airport Taxi Hire",
description: "Pune airport taxi hire service offers reliable and punctual transportation to and from Pune Airport for both domestic and international travelers. Customers can book taxis in advance for smooth pickups and drop-offs without last-minute stress. Professional drivers track flight schedules to ensure timely service even during delays or early arrivals. Comfortable vehicles with sufficient luggage space make airport transfers convenient and hassle-free. Multiple car options including sedan, SUV, and premium vehicles are available to suit every requirement. Transparent pricing ensures no hidden charges for airport rides. Services are available 24/7 for early morning and late-night flights. Ideal for business travelers, families, and tourists visiting Pune. Clean and sanitized vehicles enhance safety and comfort during travel. Experience seamless airport transfers with trusted Pune airport taxi hire services."
},
{
name: "Pune Corporate Taxi Hire",
description: "Pune corporate taxi hire service provides professional and efficient transportation solutions for business executives and corporate clients. Dedicated vehicles ensure timely pickups for office commutes, meetings, and airport transfers. Companies can benefit from customized packages for employee transportation and corporate events. Experienced drivers maintain professionalism and ensure safe travel throughout the journey. Fleet options include premium sedans, SUVs, and luxury vehicles for corporate comfort. Transparent billing and monthly plans make it convenient for businesses to manage travel expenses. Services are available round the clock for flexible scheduling. Clean vehicles and disciplined drivers ensure a premium travel experience. Ideal for IT companies, corporate offices, and business travelers. Enhance your corporate travel with reliable taxi hire services in Pune."
},
{
name: "Luxury Taxi Hire Pune",
description: "Luxury taxi hire Pune offers premium travel experience with high-end vehicles designed for comfort and style. Customers can choose from luxury sedans, SUVs, and executive cars for special occasions and business travel. Professional chauffeurs ensure smooth driving and exceptional service throughout the journey. Ideal for weddings, VIP travel, corporate events, and airport transfers. Luxury taxis provide spacious interiors, comfortable seating, and advanced features. Flexible booking options allow hourly or full-day rental services. Clean and well-maintained vehicles enhance the overall experience. Transparent pricing ensures value for premium services. Perfect for customers who prefer comfort and elegance while traveling. Experience elite transportation with luxury taxi hire services in Pune."
},
{
name: "Pune Outstation Taxi Hire",
description: "Pune outstation taxi hire service offers convenient travel for long-distance journeys to nearby cities and tourist destinations. Customers can book cabs for one-way or round trips with flexible travel options. A wide range of vehicles including sedan, SUV, and tempo travellers are available. Professional drivers ensure safe and comfortable highway travel. Ideal for family trips, business travel, and weekend getaways. Transparent pricing ensures no hidden charges during the journey. Easy online booking makes trip planning simple and hassle-free. Clean and well-maintained vehicles enhance comfort for long rides. Outstation taxi hire services are available 24/7 for all travel needs. Travel stress-free with reliable Pune outstation taxi hire services."
},
{
name: "Pune Local Taxi Rentals",
description: "Pune local taxi rentals provide convenient transportation for daily commuting and city travel. Customers can hire taxis for hourly packages or full-day usage depending on their needs. Ideal for office travel, shopping, and local sightseeing across Pune. Drivers are experienced and familiar with city routes for efficient travel. A variety of vehicle options ensures flexibility for different budgets. Affordable pricing makes local travel economical and convenient. Easy booking options allow quick reservation of taxis. Clean and well-maintained vehicles ensure a comfortable ride experience. Local taxi rentals are suitable for residents and tourists alike. Enjoy hassle-free travel within Pune with reliable taxi rental services."
},
{
name: "Pune Wedding Taxi Service",
description: "Pune wedding taxi service offers specialized transportation solutions for weddings and related events. Customers can book luxury cars, SUVs, and decorated vehicles for bride, groom, and guests. Professional drivers ensure punctual arrival and smooth coordination during events. Services include guest transportation, airport pickups, and venue transfers. Vehicles are well-maintained and can be customized as per wedding themes. Flexible packages are available for full-day or multi-day events. Reliable service ensures stress-free transportation during busy wedding schedules. Ideal for large gatherings and family functions. Clean vehicles and experienced drivers enhance the overall experience. Make your wedding travel seamless with trusted taxi services in Pune."
},
{
name: "Pune Taxi Hire for Tours",
description: "Pune taxi hire for tours provides comfortable and convenient travel for sightseeing and tourist destinations. Customers can explore popular places like Mahabaleshwar, Lonavala, Shirdi, and more with ease. Flexible packages are available for one-day or multi-day tours. Professional drivers act as guides and ensure safe travel throughout the journey. A wide range of vehicles ensures comfort for individuals and groups. Transparent pricing helps customers plan their trips effectively. Clean and well-maintained vehicles enhance the travel experience. Ideal for family trips, group tours, and vacation travel. Easy booking options add convenience for travelers. Enjoy memorable tours with reliable taxi hire services in Pune."
},
{
name: "Economy Taxi Hire Pune",
description: "Economy taxi hire Pune offers budget-friendly transportation options for daily and long-distance travel. Customers can choose affordable vehicles without compromising comfort and safety. Ideal for students, office commuters, and budget travelers. Transparent pricing ensures economical fares for all types of journeys. Professional drivers ensure safe and smooth travel. Services are available for local rides, airport transfers, and outstation trips. Easy booking options allow quick reservations. Clean vehicles provide a comfortable ride experience. Flexible travel plans suit different customer needs. Travel economically with reliable economy taxi hire services in Pune."
},
{
name: "Pune Taxi Hire for Events",
description: "Pune taxi hire for events provides reliable transportation for corporate events, parties, and social gatherings. Customers can book multiple vehicles for guest transportation and logistics. Professional drivers ensure timely service and smooth coordination. Ideal for conferences, exhibitions, and private functions. A wide range of vehicles is available for different group sizes. Flexible booking options allow customization based on event requirements. Transparent pricing ensures budget-friendly services. Clean vehicles enhance the travel experience for guests. Reliable service ensures stress-free event transportation. Make your events successful with trusted taxi hire services in Pune."
},
{
name: "Pune 24/7 Taxi Service",
description: "Pune 24/7 taxi service offers round-the-clock transportation for all travel needs. Customers can book taxis anytime for local travel, airport transfers, or outstation trips. Reliable service ensures availability even during late-night or early-morning hours. Professional drivers ensure safe and timely travel at all times. A wide range of vehicles provides options for different budgets. Transparent pricing ensures fair charges without hidden costs. Easy online booking adds convenience for users. Clean and sanitized vehicles ensure safety and comfort. Ideal for emergency travel and business needs. Travel anytime with dependable 24/7 taxi services in Pune."
},
{
name: "Pune Taxi Hire",
description: "Pune taxi hire service provides flexible transportation options for local and outstation travel. Customers can book taxis for short trips, full-day usage, or long-distance journeys. A wide range of vehicles ensures comfort and convenience. Professional drivers ensure safe and smooth travel experiences. Transparent pricing helps customers plan their journeys easily. Easy booking options allow instant reservations. Clean vehicles enhance the overall travel experience. Ideal for business, leisure, and daily commuting. Flexible packages suit different travel requirements. Choose reliable taxi hire services in Pune for hassle-free travel."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai airport cab service provides seamless intercity travel with direct drop to Mumbai Airport terminals. Comfortable vehicles ensure smooth expressway travel. Professional drivers ensure timely pickups and drop-offs for flights. One-way and round trip options are available for flexibility. Ideal for business travelers and frequent flyers. Transparent pricing ensures affordable travel costs. Easy booking options make trip planning simple. Clean vehicles ensure comfort during long journeys. Reliable service minimizes travel stress. Travel conveniently from Pune to Mumbai Airport with trusted cab services."
},
{
name: "Pune to Mumbai Cabs",
description: "Pune to Mumbai cabs offer reliable transportation between the two major cities via expressway routes. Customers can choose from sedan, SUV, and premium vehicles. Professional drivers ensure safe and timely travel. One-way and round trip options are available. Ideal for business trips, tourism, and airport transfers. Transparent pricing ensures fair fares. Easy booking options add convenience for users. Clean vehicles enhance the travel experience. Flexible travel plans suit customer needs. Enjoy comfortable travel between Pune and Mumbai with trusted cab services."
},
{
name: "Pune to Mumbai Cheapest Cab",
description: "Pune to Mumbai cheapest cab service provides budget-friendly travel options for passengers looking for economical rides. Affordable pricing ensures value for money without compromising safety. Customers can choose economical vehicle options for cost-effective travel. Professional drivers ensure smooth highway journeys. One-way cab options help reduce travel expenses. Ideal for students, solo travelers, and budget-conscious users. Transparent pricing ensures no hidden charges. Easy booking options add convenience. Clean vehicles provide comfort during travel. Travel affordably between Pune and Mumbai with cheapest cab services."
},
{
name: "Pune to Mumbai Cab Service",
description: "Pune to Mumbai cab service offers dependable intercity transportation with comfortable vehicles. Customers can book rides for business trips, family travel, or airport transfers. Professional drivers ensure safe and timely journeys. One-way and round trip options are available. Transparent pricing ensures affordable travel costs. Easy booking options provide convenience. Clean vehicles enhance the travel experience. Flexible schedules suit different travel needs. Ideal for frequent travelers between Pune and Mumbai. Enjoy hassle-free travel with reliable cab services."
},
{
name: "Cab from Pune to Mahabaleshwar",
description: "Cab from Pune to Mahabaleshwar provides scenic travel to a popular hill station destination. Comfortable vehicles ensure smooth rides through ghat roads. Professional drivers ensure safe driving in hilly terrain. Ideal for weekend trips, family vacations, and honeymoon travel. One-way and round trip options are available. Transparent pricing ensures budget-friendly travel. Easy booking options allow quick reservations. Clean vehicles enhance the travel experience. Flexible travel plans suit customer needs. Enjoy a refreshing journey to Mahabaleshwar with trusted cab services."
},
{
name: "Taxi From Pune to Mahabaleshwar",
description: "Taxi from Pune to Mahabaleshwar offers convenient and reliable travel to the hill station. Comfortable vehicles ensure smooth and safe journeys. Professional drivers ensure timely pickups and drop-offs. Ideal for tourists, families, and couples. Flexible booking options allow one-way and round trips. Transparent pricing ensures fair fares. Clean vehicles enhance comfort during travel. Easy booking options provide convenience. Scenic routes make the journey enjoyable. Travel comfortably from Pune to Mahabaleshwar with trusted taxi services."
},
{
name: "Book Cab in Pune",
description: "Book cab in Pune service provides easy and quick options for reserving taxis online or offline. Customers can book rides for local travel, airport transfers, or outstation trips. User-friendly platforms ensure seamless booking experience. Multiple vehicle options cater to different needs and budgets. Professional drivers ensure safe and timely travel. Transparent pricing ensures no hidden charges. Instant confirmation makes booking hassle-free. Clean vehicles enhance travel comfort. Flexible booking options suit different travel plans. Enjoy convenient cab booking services in Pune."
},
{
name: "Pune to Aurangabad Taxi",
description: "Pune to Aurangabad taxi service offers comfortable long-distance travel for business and tourism. Customers can explore historical sites like Ajanta and Ellora caves. Comfortable vehicles ensure smooth highway travel. Professional drivers ensure safe and timely journeys. One-way and round trip options are available. Transparent pricing ensures budget-friendly travel. Easy booking options allow quick reservations. Clean vehicles enhance travel comfort. Ideal for family trips and business travel. Travel conveniently from Pune to Aurangabad with trusted taxi services."
},
{
name: "Pune to Mumbai Cab Booking",
description: "Pune to Mumbai cab booking service provides quick and easy reservation options for intercity travel. Customers can book rides online with instant confirmation. Multiple vehicle options ensure comfort for different needs. Professional drivers ensure safe and timely journeys. One-way and round trip options are available. Transparent pricing ensures fair fares. Clean vehicles enhance the travel experience. Flexible booking options suit customer needs. Ideal for business and leisure travel. Enjoy hassle-free cab booking between Pune and Mumbai."
},
{
name: "Pune Mumbai Cabs",
description: "Pune Mumbai cabs provide reliable transportation between the two cities for various travel needs. Customers can choose from multiple vehicle options including sedan and SUV. Professional drivers ensure smooth and safe travel. One-way and round trip options are available. Transparent pricing ensures affordable fares. Easy booking options add convenience. Clean vehicles enhance comfort during travel. Ideal for business trips and tourism. Flexible travel plans suit different needs. Travel comfortably with Pune Mumbai cab services."
},
{
name: "Outstation Car Rental Pune",
description: "Outstation car rental Pune offers flexible travel options for long-distance journeys and weekend trips. Customers can rent cars for one-way or round trips to various destinations. A wide range of vehicles ensures comfort and convenience. Professional drivers ensure safe highway travel. Transparent pricing ensures budget-friendly services. Easy booking options allow quick reservations. Clean vehicles enhance the travel experience. Ideal for family trips, business travel, and tourism. Flexible packages suit different needs. Travel conveniently with outstation car rental services in Pune."
},
{
name: "Pune to Mumbai Cab One Way",
description: "Pune to Mumbai cab one way service provides economical travel options without return charges. Customers can book cabs for direct one-way journeys. Comfortable vehicles ensure smooth highway travel. Professional drivers ensure timely pickups and drop-offs. Transparent pricing ensures cost-effective travel. Ideal for business trips and airport transfers. Easy booking options provide convenience. Clean vehicles enhance travel comfort. Flexible travel plans suit customer needs. Travel affordably between Pune and Mumbai with one-way cab services."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai airport cab service offers direct transportation to Mumbai Airport terminals. Comfortable vehicles ensure smooth expressway travel. Professional drivers ensure timely arrivals for flights. One-way and round trip options are available. Transparent pricing ensures affordable fares. Easy booking options add convenience. Clean vehicles enhance the travel experience. Ideal for business travelers and families. Reliable service ensures stress-free travel. Choose trusted cab services for Pune to Mumbai airport travel."
},
{
name: "Innova Rental Pune",
description: "Innova rental Pune service offers spacious and comfortable SUV travel for families and groups. Ideal for local travel, airport transfers, and outstation trips. Customers can enjoy premium comfort with ample seating and luggage space. Professional drivers ensure safe and smooth journeys. Flexible booking options allow hourly or full-day rentals. Transparent pricing ensures value for money. Clean and well-maintained vehicles enhance the experience. Ideal for corporate travel and family vacations. Easy booking options provide convenience. Travel comfortably with Innova rental services in Pune."
}
],

tableData: [
["Pune Airport Taxi Hire","Pune Corporate Taxi Hire"],
["Luxury Taxi Hire Pune","Pune Outstation Taxi Hire"],
["Pune Local Taxi Rentals","Pune Wedding Taxi Service"],
["Pune Taxi Hire for Tours","Economy Taxi Hire Pune"],
["Pune Taxi Hire for Events","Pune 24/7 Taxi Service"],
["Pune Taxi Hire","Pune to Mumbai Airport Cab"],
["Pune to Mumbai Cabs","Pune to Mumbai Cheapest Cab"],
["Pune to Mumbai Cab Service","Cab from Pune to Mahabaleshwar"],
["Taxi From Pune to Mahabaleshwar","Book Cab in Pune"],
["Pune to Aurangabad Taxi","Pune to Mumbai Cab Booking"],
["Pune Mumbai Cabs","Outstation Car Rental Pune"],
["Pune to Mumbai Cab One Way","Pune to Mumbai Airport Cab"],
["Innova Rental Pune","Pune Airport Taxi Hire"]
],





whychoose: [
  {
    WhyChooseheading: "Professional Drivers for Pune Taxi Hire",
    WhyChoosedescription: "SRS Cab Service provides skilled and professional drivers for Pune taxi hire who are well-versed with city routes and outstation highways, ensuring safe, smooth, and timely travel."
  },
  {
    WhyChooseheading: "Budget-Friendly Taxi Hire in Pune",
    WhyChoosedescription: "We offer affordable Pune taxi hire services with transparent pricing. Customers receive clear fare details without hidden charges, making travel cost-effective and reliable."
  },
  {
    WhyChooseheading: "24/7 Pune Taxi Hire Service",
    WhyChoosedescription: "SRS Cab Service is available 24 hours a day for Pune taxi hire, including local travel, airport transfers, and outstation trips, ensuring convenience anytime."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "Our fleet includes clean, sanitized, and air-conditioned vehicles to provide maximum comfort during short city rides and long-distance taxi hire journeys."
  },
  {
    WhyChooseheading: "Flexible Taxi Hire Options",
    WhyChoosedescription: "We provide flexible Pune taxi hire services including hourly packages, full-day rentals, airport taxi hire, one-way drops, and round-trip bookings."
  },
  {
    WhyChooseheading: "Wide Range of Taxi Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers for group travel and corporate taxi hire needs."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Pune",
    WhyChoosedescription: "We offer easy doorstep pickup from homes, hotels, offices, and Pune Airport across all areas including Hinjewadi, Baner, Wakad, Kharadi, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Pune Taxi Hire Service",
    WhyChoosedescription: "SRS Cab Service is a trusted name for Pune taxi hire, known for punctual service, reliable drivers, and comfortable travel experiences."
  }
]
}

const faqData = [
  { question: "Do you provide Pune taxi hire service?", answer: "Yes, SRS Cab Service offers reliable Pune taxi hire for local travel, airport transfers, and outstation trips." },
  { question: "Is Pune taxi hire available 24/7?", answer: "Yes, our taxi hire service in Pune is available 24 hours a day for all travel needs." },
  { question: "What areas do you cover in Pune?", answer: "We cover all major areas including Hinjewadi, Wakad, Baner, Aundh, Kharadi, Hadapsar, and Pune Airport." },
  { question: "Which vehicles are available for taxi hire?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers." },
  { question: "Do you provide Pune Airport taxi hire?", answer: "Yes, we offer airport pickup and drop services with timely taxi hire in Pune." },
  { question: "Can I hire a taxi for outstation travel from Pune?", answer: "Yes, we provide taxi hire for outstation trips from Pune to Mumbai, Shirdi, Nashik, Mahabaleshwar, and more." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all our taxi hire vehicles are fully air-conditioned for comfortable travel." },
  { question: "How can I book Pune taxi hire?", answer: "You can book easily through phone or online booking for quick and hassle-free service." },
  { question: "Do you provide one-way taxi hire?", answer: "Yes, one-way and round-trip taxi hire options are available." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Patil",
    feedback:
      "Excellent Pune taxi hire service by SRS. The driver was professional and the journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Joshi",
    feedback:
      "Very affordable and reliable taxi hire in Pune. I booked for airport drop and service was perfectly on time.",
    rating: 5
  }
];



































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Taxi Hire | SRS Cab",
  "description": "SRS Cab provides reliable Pune Taxi Hire services including Airport Taxi Hire, Corporate Taxi Hire, Luxury & Economy Taxis, Outstation Trips, Local Rentals, Wedding Taxi Service, Tours, and 24/7 Taxi Service. Book Pune to Mumbai, Pune to Mumbai Airport, Pune to Mahabaleshwar, Pune to Aurangabad, and other one-way or round trips. Enjoy safe, comfortable, and punctual rides with online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      <Helmet>
  <title>Pune Taxi Hire | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune Taxi Hire with SRS Cab. Offering Airport, Corporate, Luxury, Economy, Outstation & Local Taxi Rentals. Pune to Mumbai, Mumbai Airport, Mahabaleshwar, Aurangabad trips with 24/7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/2.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetaxihire;